<template>
  <div>
    <!-- 搜索/新增 -->
    <div class="list-hd">
      <el-form :inline="true" v-model="searchValue" class="demo-form-inline">
        <el-form-item label="身份证：">
          <el-input v-model="searchValue.id_card"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain @click="searchWhiteIdNumberList"
            >查询</el-button
          >
          <el-button type="success" plain @click="addWhiteIdNumberDialog"
            >新增黑名单</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="onExport()"
            >导出</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <!-- 黑名单列表展示 -->
    <el-table
      stripe
      ref="table"
      v-loading="loadingData"
      :data="tableData"
      :max-height="tableHeight"
      border
      style="width: 100%"
    >
      <el-table-column prop="id" label="ID" width="150"> </el-table-column>
      <el-table-column prop="created_at" label="创建日期"> </el-table-column>
      <el-table-column prop="id_card" label="身份证"> </el-table-column>
      <el-table-column prop="admin.name" label="操作人员"> </el-table-column>
      <el-table-column prop="remark" label="备注"> </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="danger" plain @click="del_blackIdNumber(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalRecords"
      >
      </el-pagination>
    </div>

    <!-- 添加黑名单弹出框 -->
    <el-dialog
      title="添加黑名单"
      :visible.sync="addDialogFormVisible"
      width="40%"
      class="addWhite"
    >
      <el-form>
        <el-form-item label="身份证:">
          <el-input v-model="id_card"></el-input>
        </el-form-item>
        <el-form-item label="备注:">
          <el-input v-model="remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addWhiteIdNumberSubmit()"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import fetch from "@/assets/js/axios.js";
import { urlSplicing } from "@/assets/js/public.js";
export default {
  name: "blackIdNumber",
  components: {},
  data() {
    return {
      loadingData: false,
      addDialogFormVisible: false,
      searchValue: {
        id_card: "",
      },
      historyValue: "",
      tableHeight: 0,
      tableData: [],
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      id_card: "",
      remark: "",
    };
  },
  computed: {
    ...mapState(["host"]),
  },
  created() {
    this.getWhiteIdNumberList(true);
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["table"].doLayout();
    });
  },
  beforeMount(height) {
    var h = document.documentElement.clientHeight;
    this.tableHeight = h - 60; //减去页面上固定高度height
  },
  methods: {
    // 导出
    onExport() {
      let params = {
        ...this.historyValue, // 传对应的搜索的值
        export: 1,
        token: sessionStorage.getItem("access_token"),
      };

      urlSplicing(this.host + "admin/black_id_card/list", params);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getWhiteIdNumberList(false);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getWhiteIdNumberList(false);
    },
    // 实现游戏数据搜索
    searchWhiteIdNumberList() {
      this.currentPage = 1;
      this.getWhiteIdNumberList(true);
    },
    // 删除
    del_blackIdNumber(id) {
      this.$confirm("是否确定删除该数据?", "操作确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.del_blackIdNumberSubmit(id);
        })
        .catch(() => {});
    },
    del_blackIdNumberSubmit(id) {
      fetch({
        url: "/admin/black_id_card/delete",
        method: "GET",
        params: {
          id: id,
        },
      }).then((res) => {
        if (res.data.status) {
          this.$message({
            type: "success",
            message: "删除成功！",
          });
          this.getWhiteIdNumberList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 新增黑名单
    addWhiteIdNumberDialog() {
      this.id_card = "";
      this.remark = ""
      this.addDialogFormVisible = true;
    },
    // 新增黑名单提交操作
    addWhiteIdNumberSubmit() {
      fetch({
        url: "/admin/black_id_card/add",
        method: "POST",
        data: {
          id_card: this.id_card,
          remark: this.remark,
        },
      }).then((res) => {
        if (res.data.status) {
          this.$message({
            type: "success",
            message: "新增黑名单成功！",
          });
          this.addDialogFormVisible = false;
          this.getWhiteIdNumberList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    // 展示拉黑列表数据
    getWhiteIdNumberList(reload = false) {
      let searchValue = {};
      if (reload) {
        this.historyValue = JSON.parse(JSON.stringify(this.searchValue));
        searchValue = this.searchValue;
      } else {
        searchValue = this.historyValue;
      }
      this.loadingData = true;
      fetch({
        url: "/admin/black_id_card/list",
        method: "GET",
        params: {
          ...searchValue,
          page: this.currentPage,
          per_page: this.pageSize,
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.tableData = res.data.data.data;
            this.totalRecords = res.data.data.total;
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
  },
};
</script>
<style lang="less">
a {
  text-decoration: none;
  color: #606266;
}
.pagination {
  text-align: right;
  margin-top: 20px;
  padding-bottom: 20px;
}
.list-hd {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  .el-input-group {
    width: 370px;
  }
}
.addWhite {
  .el-form-item {
    display: flex;
    // justify-content: center;
    .el-input {
      width: 320px;
    }
  }
}
</style>
